import { Stepper } from "shared/app/InviteAndCreateModal/slices/InviteApplicants/components/Stepper";
import { Step } from "views/settings-integration/components/AddIntegrationModal/types";

interface HeaderProps {
  currentStep: Step;
}

export const Header = ({ currentStep }: HeaderProps) => {
  return (
    <>
      <h1 className="font-bold text-xl">
        {currentStep === Step.FIRST ? "Choose integration" : "Add credentials"}
      </h1>
      <div className="my-6">
        <Stepper currentStepIdx={Number(currentStep)} totalSteps={2} />
      </div>
    </>
  );
};
